import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import CheckboxField from '../BaseInputs/CheckboxField';
import OnOffField from '../BaseInputs/OnOffField';
import OnOffCheckboxField from '../BaseInputs/OnOffCheckboxField';
import NumberWithTwoDecimalsCheckBox from '../BaseInputs/NumberWithTwoDecimalsCheckBox';
import BoolField from '../BaseInputs/Selectors/BoolField';
import EmptyYesNoSelect from '../BaseInputs/Selectors/EmptyYesNoSelect';
import SelectFieldCheckbox from '../BaseInputs/Selectors/SelectFieldCheckbox';

export const renderCheckboxField = (props) => (
  <CheckboxField
    value={props.value}
    className={props.className}
    onChange={(value) => props.onChange(props.fieldName, value)}
  />
);

export const renderOnOffField = (props) => (
  <OnOffField
    value={props.value}
    className={props.className}
    onChange={(value) => props.onChange(props.fieldName, value)}
  />
);

export const renderOnOffCheckBoxField = (props) => (
  <OnOffCheckboxField
    value={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
  />
);

export const renderNumberWithTwoDecimalsCheckBox = (props) => (
  <NumberWithTwoDecimalsCheckBox
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    changeOfEditedMultipItem={props.changeOfEditedMultipItem}
    editedItem={props.editedItem}
    IsCheckBoxEnabled={props.IsCheckBoxEnabled}
    onOffValue={props.onOffValue}
    onChange={props.onChange}
  />
);

export const renderBoolField = (props) => (
  <BoolField
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    editedItem={props.editedItem}
    IsCheckBoxEnabled={props.IsCheckBoxEnabled}
  />
);

export const renderEmptyYesNoSelect = (props) => (
  <EmptyYesNoSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
  />
);

export const renderSelectFieldCheckBox = (props) => (
  <SelectFieldCheckbox
    value={props.value}
    className={props.className}
    showSelectFilterAt={props.showSelectFilterAt}
    filterCleared={props.filterCleared}
    selectValues={props.selectValues}
    IsCheckBoxEnabled={props.IsCheckBoxEnabled}
    onOffValue={props.onOffValue}
    editedItem={props.editedItem}
    changeOfEditedMultipItem={props.changeOfEditedMultipItem}
    fieldName={props.fieldName}
    onChange={props.onChange}
  />
);
